<template>
	<TimeEntryActionsInput
		:task-id="taskId"
		:default-time-entry-value="DEFAULT_TIME_ENTRY_VALUE"
		is-modify-allowed
		@close="$emit('close')"
		@blur="$emit('close')"
		@add="onAdd"
		@modify="onModify"
	/>
</template>

<script setup lang="ts">
import { useTimeEntryActionsMutation, type Task } from '@/generated/graphql';
import TimeEntryActionsInput from './TimeEntryActionsInput.vue';
import { useMfeUtils } from '@/composables';
import { DEFAULT_TIME_ENTRY_VALUE } from '../../constants';

export type TimeEntryActionsAddEntryProps = {
	taskId: Task['id'];
};

const props = defineProps<TimeEntryActionsAddEntryProps>();

defineEmits<{
	(e: 'close'): void;
}>();

const { rootEmit } = useMfeUtils();
const { mutate } = useTimeEntryActionsMutation({});

const onAdd = async (duration: number) => {
	await mutate({
		input: {
			taskId: props.taskId,
			duration,
		},
	});
};

const onModify = (duration: number) => {
	rootEmit('modify-time-entry', {
		taskId: props.taskId,
		duration,
		isCompleted: true,
	});
};
</script>
